<template>
    <div class="pass-type-card media-block">
        <div class="pass-type-card__image media-block__image">
            <img class="img-fluid" 
                 :src="item.image + '?anchor=center&mode=crop&width=640&height=480'" 
                 :srcset="renderSrcset(item)"
                 width="640" height="480" alt="Card image cap">
        </div>
        <div class="pass-type-card__content media-block__content">
            <div class="card-body media-block__content__text stack">
                <h2 class="header--small">{{ item.title }} </h2>
                <ul v-show="item.perkTypes.length > 0" class="icon-list">
                    <li v-for="(y, index) in item.perkTypes" class="icon-with-text">
                        <span v-html="renderSvg(y, perkTypes)"></span> {{ renderName(y, perkTypes) }}
                    </li>
                </ul>

                <ul class="icon-list">
                    <li class="icon-with-text">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                                <path d="M11.677 28.364c-.566 0-1.202-.212-1.627-.636l-8.414-8.415c-.425-.424-.566-.99-.637-1.626 0-.566.212-1.202.637-1.626L16.909.787c.849-.848 2.334-.92 3.111 0l8.415 8.415c.849.848.849 2.262 0 3.252L13.232 27.657c-.353.495-.919.778-1.555.707zm-8.91-11.172c-.141.141-.212.354-.212.495s0 .424.141.566l8.415 8.414c.283.283.778.354.99 0l15.273-15.273a.764.764 0 00.213-.495.764.764 0 00-.213-.495L18.96 1.989c-.283-.283-.849-.283-.99 0L2.767 17.192z" />
                                <path d="M10.6 31.8c-.3 0-.6-.1-.8-.2-.6-.2-1-.7-1.2-1.2l-3-7.2c-.2-.4 0-.8.4-1 .4-.2.8 0 1 .4l3 7.2c.1.2.2.3.4.4.2.1.4.1.6 0l18-7.6c.2-.1.3-.2.4-.4.1-.2.1-.4 0-.6l-3.2-7.5c-.2-.4 0-.8.4-1s.8 0 1 .4l3.2 7.5c.2.6.2 1.2 0 1.7-.2.6-.7 1-1.2 1.2l-18.2 7.7c-.2.2-.5.2-.8.2z" />
                            </svg>
                        </span> {{ getSelectedPassTypesAsString(item, passTypes) }}
                    </li>
                </ul>

            </div>

            <div class="card-link-wrapper media-block__content__cta u-text-right" v-show="item.link.url.length > 0">
                <a :href="item.link.url" :taget="item.link.target" class="link-button link-button--primary">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" width="16" height="12" aria-hidden="true" focusable="false">
                        <path d="M11.5355339 5L8.2426407 1.7071068c-.3905243-.3905243-.3905243-1.0236893 0-1.4142136.3905243-.39052427 1.0236893-.39052427 1.4142135 0l5.6568543 5.6568543-5.6568543 5.6568542c-.3905242.3905243-1.0236892.3905243-1.4142135 0-.3905243-.3905243-.3905243-1.0236893 0-1.4142135L11.4350288 7H1c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h10.5355339z"></path>
                    </svg>
                    <span>{{item.link.label}}</span>
                </a>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                test: ''
            }
        },
        props: {
            // this component expects a prop of type object
            item: {
                type: Object,
                required: true
            },
            passTypes: {
                type: Array,
                required: true
            },
            perkTypes: {
                type: Array,
                required: true
            }
        },
        computed: {
            getSelectedPerksAsString: function (item, perkTypes) {
                //console.log("ALL PERKS: ", perkTypes)

                var selectedPerksArray = [];
                item.perkTypes.forEach(function (perkTypeId) {
                    var foundPerkTypeIndex = perkTypes.findIndex(x => x.id === perkTypeId)
                    selectedPerksArray.push(perkTypes[foundPerkTypeIndex]);
                });

                //console.log(selectedPerksArray);
                return selectedPerksArray;

            }

        },
        methods: {

            renderSrcset(item) {

                if (item.image) {
                    return `
                        ${item.image}?anchor=center&mode=crop&width=640&height=480 640w,
                        ${item.image}?anchor=center&mode=crop&width=960&height=720 960w,
                        ${item.image}?anchor=center&mode=crop&width=1280&height=960 1280w
                        `
                }
                return "";
                
            },

            renderName(val, perkTypes) {
                
                var foundPerkTypeIndex = perkTypes.findIndex(x => x.id === val)
                //console.log(foundPerkTypeIndex);

                return perkTypes[foundPerkTypeIndex].name
            },
            renderSvg(val, perkTypes) {

                var foundPerkTypeIndex = perkTypes.findIndex(x => x.id === val)
                //console.log(foundPerkTypeIndex);

                return perkTypes[foundPerkTypeIndex].rawSvg
            },
            getSelectedPassTypesAsString: function (item, passTypes) {

                var selectedPassTypesArray = [];
                item.passTypes.forEach(function (passTypeId) {
                    var foundPassTypeIndex = passTypes.findIndex(x => x.id === passTypeId)
                    selectedPassTypesArray.push(passTypes[foundPassTypeIndex].name);
                });

                return selectedPassTypesArray.join(" - ");

            },


        }
    };
</script>